import { IRootState } from '../../../store'
import { IMedicalConsultOptionsState } from '../store/options.types'

export const getMedicalConsultOptionsSelector = (state: IRootState): IMedicalConsultOptionsState =>
  state.options.medicalConsultOptions
